import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MusterAttendanceService } from '../../Model/MusterAttendance/muster-attendance.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { SessionService } from '../../Util/Session/session.service';

@Component({
  selector: 'app-muster-attendance-send-poc',
  standalone: true,
  imports: [CommonModule, LoaderComponent, FormsModule, DataTablesModule],
  templateUrl: './muster-attendance-send-poc.component.html',
  styleUrl: './muster-attendance-send-poc.component.scss'
})
export class MusterAttendanceSendPOCComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);

  @Input() SiteMasterID: number = 0;
  @Input() MonthYear: any = null;
  @Input() Type: any = null;
  @Input() SiteName: any = null;
  Datas = [] as any;
  user = [] as any;

  dtTrigger: Subject<any> = new Subject<any>();

  Filter = {
    SelectType: '',
    SiteId: null as any,
    MonthName: null as any,
    YearName: null as any,
    MailId: null as any,
    IsMonthlySummary: false,
    IsBillingSummary: false,
    ApprovalStatus: null,
    CompanyCode: null,
    DomainName: null,
  }

  constructor(
    private musterAttendance: MusterAttendanceService,
    private toast: ToastService,
    private dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    private session: SessionService,
  ) {
    this.user = this.session.GetUserDetails();
  }

  dtOptions: DataTables.Settings = {
    pagingType: 'full_numbers',
    searching: false,
    paging: false,
    scrollY: '350px',
    scrollCollapse: true,
    pageLength: 10,
    info: false,
    lengthMenu: [10, 25, 50, 100],
    language: {
      searchPlaceholder: 'Search...',
    },
    stateSave: true,
    processing: false,
    order: [[0, 'asc']],
    createdRow: (row: Node, data: any, index: number) => {
      const $checkbox = $(row).find('.row-checkbox');

      $checkbox.prop('checked', data.selected ?? false);

      $checkbox.off('change').on('change', (event: any) => {
        const isChecked = event.target.checked;
        data.selected = isChecked;
        this.Datas[index].selected = isChecked;
      });
    },
    columnDefs: [
      {
        targets: 0,
        width: '50px',
      },
      {
        targets: 1,
        width: '60px',
      }
    ],
    columns: [
      {
        title: '#',
        data: null,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<strong>${meta.row + (meta.settings.displayStart ?? 0) + 1}</strong>`;
        },
        orderable: true,
        width: '50px'
      },
      {
        title: `Check`,
        data: null,
        orderable: false,
        render: (data: any, type: any, row: any, meta: any) => {
          return `<input type="checkbox" class="row-checkbox" data-row-index="${meta.row}">`;
        },
      },
      {
        title: 'Name',
        data: (row: any) => {
          return this.Type == 'I' ? row.InternalPOCName : row.ClientPOCName;
        },
        orderable: true,
      },
      {
        title: 'Email',
        data: (row: any) => {
          return this.Type == 'I' ? row.InternalPOCMailId : row.ClientPOCMailId;
        },
        orderable: true,
      },
      {
        title: 'Mobile No',
        data: (row: any) => {
          return this.Type == 'I' ? row.InternalPOCMobileNo : row.ClientPOCMobileNo;
        },
        orderable: true,
      },
    ],
  };

  ngOnInit(): void {
    this.ESS_LoadAttendanceOAS();
  }

  ESS_LoadAttendanceOAS() {
    this.isDisabled = true;
    this.Datas = [];
    this.musterAttendance.ESS_LoadAttendanceOAS({
      'SelectType': 'POC', SiteId: this.SiteMasterID,
      MonthName: this.dateFormate.fullmonth[this.MonthYear.month - 1], YearName: this.MonthYear.year,
      EmpMasterId: 0, AttendanceDate: null, DesignationMasterId: 0, DutyMasterId: 0, ShiftMasterId: 0,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          if (this.Type == 'I' && !response.Table[0].IsInternalPOCApplicable) {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Internal POC Not Allow";
            modalRef.result.then((result: any) => {
              if (result) {
                this.close(false);
              }
            });
          } else if (this.Type == 'C' && !response.Table[0].IsClientPOCApplicable) {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Client POC Not Allow";
            modalRef.result.then((result: any) => {
              if (result) {
                this.close(false);
              }
            });
          } else {
            this.Datas = response.Table;
          }
        }
        this.initializeDataTable('#summarydata', Object.values(this.Datas));
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Validate(form: any) {
    if (form.valid) {
      if (this.Filter.MailId == null || this.Filter.MailId == "") {
        this.Filter.MailId = this.Datas.filter((e: any) => e.selected).map((e: any) => this.Type == 'I' ? e.InternalPOCMailId : e.ClientPOCMailId).toString();
      } else {
        this.Filter.MailId += ',' + this.Datas.filter((e: any) => e.selected).map((e: any) => this.Type == 'I' ? e.InternalPOCMailId : e.ClientPOCMailId).toString();
      }
      if (this.Filter.MailId != null && this.Filter.MailId != "") {
        this.ESS_SiteWiseAttendanceSendToPOCOAS();
      } else {
        this.toast.show({ message: 'Please select emailid or enter emailid.', type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_SiteWiseAttendanceSendToPOCOAS() {
    this.isDisabled = true;

    this.Filter.SelectType = this.Type == 'I' ? 'IPOC' : 'CPOC';
    this.Filter.SiteId = this.SiteMasterID;
    this.Filter.MonthName = this.dateFormate.fullmonth[this.MonthYear.month - 1];
    this.Filter.YearName = this.MonthYear.year;
    this.Filter.CompanyCode = this.user.CompanyCode;
    this.Filter.DomainName = this.user.Domain;

    this.musterAttendance.ESS_SiteWiseAttendanceSendToPOCOAS(this.Filter).subscribe({
      next: (response) => {
        if (response.Error_Code == '01') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.close(true);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  initializeDataTable(selector: string, data: any[]) {
    if ($.fn.dataTable.isDataTable(selector)) {
      $(selector).DataTable().destroy();
      $(selector).empty();
    }

    const table = $(selector).DataTable({
      data: data,
      ...this.dtOptions
    });
  }

  close(flag = false) {
    this.activeModal.close(flag);
  }
}
